import { render, staticRenderFns } from "./historyRequest.vue?vue&type=template&id=4d86ec2e&"
import script from "./historyRequest.vue?vue&type=script&lang=js&"
export * from "./historyRequest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports